<template>
  <layout-component>
    <div class="container" v-if="post">
        <div class="row justify-content-md-center banner pb-1 pb-md-0">
          <div class="col-md-7 title-wrapper">
            <div class="date">{{ post.date | formatDateBlog }}</div>
            <h1 class="left-bullet">{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h1>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="img-wrapper img-header">
              <div class="noise">
                <img class="img-fluid" v-if="post.image" :src="'/storage/'+post.image" loading="lazy" :alt="$i18n.locale == 'fr' ? post.title : post.title_en" />
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="body" v-html="$i18n.locale == 'fr' ? post.body : post.body_en"></div>
          </div>
        </div>

        <div class="row pt-3 pt-md-4 other-posts">
          <div class="col-md-8 pb-2 pb-md-3 offset-md-2">
            <h2 class="left-bullet" v-html="$t('w.blogpost.title-01')"></h2>
          </div>

          <div v-for="post in post.otherPosts" class="col-md-6">
            <div class="card-blog">
              <router-link :to="'/blog/post/'+post.slug">
              <div class="img-wrapper">
                <div class="noise">
                  <img class="img-fluid"  v-if="post.image" :src="'/storage/'+post.image" loading="lazy" :alt="$i18n.locale == 'fr' ? post.title : post.title_en" />
                </div>
              </div>
              <div class="text-wrapper">
                <div class="date bottom-cut">{{ post.date | formatDateBlog }}</div>
                <h3>{{ $i18n.locale == 'fr' ? post.title : post.title_en }}</h3>
                <p class="btn-link">{{'w.blogpost.title-btn'|t}}</p>
              </div>
              </router-link>
            </div>
          </div>
        </div>


    </div>

	</layout-component>
</template>

<script>
    export default {
      data() {
        return {
          post:null
        }
      },
      created() {
        this.getPost()
      },
      watch: {
        // call again the method if the route changes
        '$route': 'getPost'
      },
      methods: {
        getPost() {
          Vue.axios.get('/blog/'+this.$route.params.id).then( ({data}) => {
            this.post = data
          }).catch(() => {})
        }
      },
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');

        $('.noise').each(function() {
          if ($(this).is( ':in-viewport' ) ) {
            $(this).addClass('in-viewport');
          } else {
            $(this).removeClass('in-viewport');
          }
        });
      }
    }
</script>
